export const getSocialServiceOperationsFrag = `
    id
    name
    type
    billCode
    mpsvBasic
    mpsvMeeting
    noRecord
    facultativeCode
    informationCode
    unit
    payment
    maxPrice
    maxPriceExt
    validFrom
    validTo
`;

export const getSocialServiceRegionsFrag = `
    id
    name
    description
    mpsvRegion
    billCode
    validFrom
    validTo
`;
